import { render, staticRenderFns } from "./S9.vue?vue&type=template&id=4db74567&scoped=true&"
import script from "./S9.vue?vue&type=script&lang=js&"
export * from "./S9.vue?vue&type=script&lang=js&"
import style0 from "./S9.vue?vue&type=style&index=0&id=4db74567&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db74567",
  null
  
)

export default component.exports